import dynamic from 'next/dynamic';
import { clsx } from 'clsx';

import { DISTRIBUTOR_NAME } from '@autopass-web/domain';

import { BottomNavBar } from '../../../components/toyota-lexus/bottom-nav-bar';
import Primary from '../../../layout/primary';
import { CURRENT_DISTRIBUTOR } from '../../../new-distributor-config';

import type {
  BasePoiCharacteristics,
  FilterOptions,
  PinType,
} from '@autopass-web/feature-maps';
import type { Poi } from '@autopass-web/types';

const BOTTOM_NAV_BAR_HEIGHT = 60;

const FeatureMaps = dynamic(() => import('@autopass-web/feature-maps'), {
  ssr: false,
});

export const PlusPayMapPage = () => {
  return (
    <Primary>
      <div className={clsx('w-full', 'h-full', 'relative')}>
        <FeatureMaps
          basePath="/maps"
          isNextModule
          parsePinType={parsePinType}
          events={{
            distributorName: DISTRIBUTOR_NAME[CURRENT_DISTRIBUTOR],
          }}
          poiCardTutorialConfig={{ isExternallyNavigable: false }}
          basePoiCharacteristics={MAP_BASE_POI_CHARACTERISTICS}
          customFilterOptions={MAP_CUSTOM_FILTER_OPTIONS}
          bottomAdditionalOffset={BOTTOM_NAV_BAR_HEIGHT}
        />
      </div>
      <BottomNavBar />
    </Primary>
  );
};

const MAP_BASE_POI_CHARACTERISTICS = {
  parkinglot: {
    cooperationStates: ['coming_soon', 'in_cooperated'],
  },
} as BasePoiCharacteristics;

const MAP_CUSTOM_FILTER_OPTIONS = {
  parkinglot: {
    parkingServices: ['autopass'],
    vehicleTypes: ['car', 'moto'],
    payTaipeiCategories: ['pay_taipei_no_card_entry_exit'],
  },
} as FilterOptions;

function parsePinType(poi: Poi): PinType {
  switch (poi.type) {
    case 'Parkinglot': {
      const { cooperation_state } = poi;
      if (cooperation_state === 'in_cooperated') return 'parkinglot-autopass';

      return 'parkinglot';
    }
    default:
      throw new Error('parsePinType: Invalid poi type');
  }
}
